/**
 * Use instead of the "./module" to avoid authentication in the app
 */

export default angular.module('edge.platform.auth', []).provider('gwAuthTokenService', { // do nothing
    $get: function $get() {
        return {};
    }
}).provider('gwInactivityTimerService', { // do nothing
    $get: function $get() {
        return {
            resetInactivityTimer: function resetInactivityTimer() {
                return true;
            }
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/module-anonymous.js
// module id = 875
// module chunks = 0